module.exports = __webpack_public_path__ + "static/media/read_content_aloud_tamil.aa69695d.mp3";